module.exports = __webpack_public_path__ + "static/media/215.6f3c6c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/215.jpg
// module id = 957
// module chunks = 0